module.exports = __webpack_public_path__ + "c7f8c11745b5800eb11883662f5e06c4.svg";